import React from 'react';
import { FaImage } from 'react-icons/fa';

interface ImageButtonProps {
  onClick: () => void;
}

export const ImageButton: React.FC<ImageButtonProps> = ({ onClick }) => {
  return (
    <button
      className='toolbar-button'
      onClick={onClick}
      title='ファイル'
      type='button'
    >
      <FaImage />
    </button>
  );
};
